import React from "react";
import styled from "styled-components";

const Container = styled.div`
    width:100%;
    border-radius:28px;
    overflow:hidden;

    background:
        radial-gradient(circle at top right,#8D5CFF 0%,transparent 35%),
        radial-gradient(circle at bottom left,#00D4A4 0%,transparent 35%),
        linear-gradient(135deg,#1B2130 0%,#121722 100%);

    padding:28px;
    color:white;

    display:flex;
    flex-direction:column;
    gap:18px;

    box-shadow:0 20px 40px rgba(0,0,0,.35);
`;

const Header = styled.div`
    display:flex;
    justify-content:space-between;
    align-items:center;
`;

const Welcome = styled.div`
    display:flex;
    flex-direction:column;
`;

const Small = styled.span`
    font-size:14px;
    opacity:.8;
`;

const Name = styled.span`
    font-size:30px;
    font-weight:700;
`;

const Level = styled.div`
    background:rgba(255,255,255,.12);
    padding:10px 16px;
    border-radius:16px;
    font-weight:600;
`;

const Career = styled.div`
    display:flex;
    flex-direction:column;
`;

const Label = styled.span`
    font-size:13px;
    opacity:.75;
`;

const CareerName = styled.span`
    font-size:24px;
    font-weight:700;
`;

const CareerSelect = styled.select`

    margin-top:6px;

    background:rgba(255,255,255,.08);

    color:white;

    border:none;

    border-radius:12px;

    padding:8px 14px;

    font-size:24px;

    font-weight:700;

    width:max-content;

    outline:none;

    cursor:pointer;

    option{

        color:black;

    }

`;

const CareerInfo = styled.span`

    margin-top:6px;

    font-size:13px;

    opacity:.75;

`;

const ScoreRow = styled.div`
    display:grid;
    grid-template-columns:1fr 1fr;
    gap:18px;
`;

const ScoreBox = styled.div`
    background:rgba(255,255,255,.08);
    padding:18px;
    border-radius:18px;
`;

const ScoreTitle = styled.div`
    font-size:13px;
    opacity:.75;
`;

const Score = styled.div`
    margin-top:6px;
    font-size:36px;
    font-weight:700;
`;

const ProgressWrapper = styled.div`
    margin-top:10px;
`;

const ProgressText = styled.div`
    display:flex;
    justify-content:space-between;
    margin-bottom:8px;
    font-size:13px;
`;

const Bar = styled.div`
    height:12px;
    border-radius:20px;
    overflow:hidden;
    background:rgba(255,255,255,.10);
`;

const Fill = styled.div`
    height:100%;
    width:${props=>props.value}%;
    border-radius:20px;

    background:linear-gradient(
        90deg,
        #00E5A8,
        #00C2FF
    );

    transition:.5s;
`;

const Footer = styled.div`
    display:flex;
    justify-content:space-between;
    flex-wrap:wrap;
    gap:16px;
`;

const FooterItem = styled.div`
    display:flex;
    flex-direction:column;
`;

const FooterValue = styled.span`
    font-size:22px;
    font-weight:700;
`;

const FooterLabel = styled.span`
    font-size:12px;
    opacity:.75;
`;

export default function HeroCard({

    nombre="Estudiante",

    nivel=1,

    carrera="",

    universidad="",

    ciudad="",

    carreras=[],

    carreraSeleccionada,

    onCambiarCarrera,

    puntajeEstimado=0,

    puntajeObjetivo=0,

    probabilidad=0,

    xp=0,

    racha=0,

    examenes,

examenSeleccionado,

onCambiarExamen,

}){ 

    const porcentaje =

puntajeObjetivo>0

?

Math.min(

100,

Math.round(

puntajeEstimado/

puntajeObjetivo*

100

)

)

:

0;

    return(

        <Container>

            <Header>

                <Welcome>

                    <Small>
                        Bienvenido nuevamente
                    </Small>

                    <Name>
                        {nombre}
                    </Name>

                </Welcome>

                <Level>

                    Nivel {nivel}

                </Level>

            </Header>

            <Label>

    Examen objetivo

</Label>

<CareerSelect

    value={examenSeleccionado}

    onChange={e=>

        onCambiarExamen(

            Number(e.target.value)

        )

    }

>

    {

        examenes.map(examen=>(

            <option

                key={examen.ID}

                value={examen.ID}

            >

                {examen.Examen}

            </option>

        ))

    }

</CareerSelect>

            <Career>

    <Label>

        Carrera objetivo

    </Label>

    <CareerSelect

        value={

            carreraSeleccionada ?? ""

        }

        onChange={e=>

            onCambiarCarrera(

                Number(

                    e.target.value

                )

            )

        }

    >

        {carreras.map(c=>

            <option

                key={c.ID}

                value={c.ID}

            >

                {c.Carrera}

            </option>

        )}

    </CareerSelect>

    <CareerInfo>

        {universidad}

        {ciudad && ` · ${ciudad}`}

    </CareerInfo>

</Career>

            <ScoreRow>

                <ScoreBox>

                    <ScoreTitle>

                        Puntaje estimado

                    </ScoreTitle>

                    <Score>

                        {puntajeEstimado}

                    </Score>

                </ScoreBox>

                <ScoreBox>

                    <ScoreTitle>

                        Puntaje requerido

                    </ScoreTitle>

                    <Score>

                        {puntajeObjetivo}

                    </Score>

                </ScoreBox>

            </ScoreRow>

            <ProgressWrapper>

                <ProgressText>

                    <span>

                        Progreso hacia la meta

                    </span>

                    <span>

                        {porcentaje}%

                    </span>

                </ProgressText>

                <Bar>

                    <Fill value={porcentaje}/>

                </Bar>

            </ProgressWrapper>

            <Footer>

                <FooterItem>

                    <FooterValue>

                        {probabilidad}%

                    </FooterValue>

                    <FooterLabel>

                        Probabilidad

                    </FooterLabel>

                </FooterItem>

                <FooterItem>

                    <FooterValue>

                        {xp}

                    </FooterValue>

                    <FooterLabel>

                        XP

                    </FooterLabel>

                </FooterItem>

                <FooterItem>

                    <FooterValue>

                        🔥 {racha}

                    </FooterValue>

                    <FooterLabel>

                        Racha

                    </FooterLabel>

                </FooterItem>

            </Footer>

        </Container>

    );

}